import { EntityName } from 'record-it-time-common/EntityName';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';

export function useUserGroupDeleteHandler(userGroup: UserGroup): () => void {
  return useEntityDeleteHandler(
    EntityName.UserGroup,
    userGroup,
    (ug) => ug.name
  );
}
